import React from 'react'
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import { parseYearPickerValue } from "../../app/helpers/yearPickerHelper";

const ViewYearGeneric = ({ values, field, moduleText, occupation }) => {
    const { t } = useTranslation();
    const selectedYear = parseYearPickerValue(values[field]);
    return (
        <div className={`col-md-${occupation} viewContentGroup`}>
            <label htmlFor="name" className="tit-view-view tit-content-view-view">
                {t(`${moduleText}.synthetic.${field}`)}
            </label>
            <br />
            <DatePicker
                showYearPicker
                readOnly
                dateFormat="yyyy"
                className="txt-view viewContentTxt border-none"
                selected={selectedYear}
                id={field}
                name={field}
            />
        </div>
    )
}

export default ViewYearGeneric
